import React, { useState, forwardRef, useEffect } from "react";

import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import studentsAPI from "../../../../services/students";
import { Dropdown } from "primereact/dropdown";
import classesAPI from "../../../../services/classes";

const UpdateRegistrationClasseModal = forwardRef((props, ref) => {
  //
  const schoolId = props?.schoolId;
  const trainingId = props?.trainingId;
  const accessToken = "";
  //
  const [registrationClasse, setRegistrationClasse] = useState(props?.student?.class_id);
  //
  useEffect(() => {
    setRegistrationClasse(props?.student?.class_id);
  }, [props]);
  //
  const classesQuery = classesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    100000,
    {
      level_id: props?.student?.level_id || "",
    }
  );
  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Modifier la classe"
        serviceAPI={studentsAPI}
        schoolId={schoolId}
        trainingId={trainingId}
        id={props?.student?.id}
        data={{
          class_id: registrationClasse,
        }}
      >
        <Dropdown
          //value={registrationClasse}
          value={classesQuery?.data?.data?.find(
            (obj) => obj.id === registrationClasse
          )}
          options={classesQuery?.data?.data}
          onChange={(e) => setRegistrationClasse(e.value?.id)}
          optionLabel="name"
          placeholder="Sélectionner une classe"
          checkmark={true}
        />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateRegistrationClasseModal;
